// src/services/registroSensoresService.js
import api from "./Api"; // tu wrapper axios

const registroSensoresService = {
  // GET /registros-sensores/sensor/{sensorId}?page=&pageSize=&desdeUtc=&hastaUtc=&desc=
  async getPorSensor(
    sensorId,
    { page = 1, pageSize = 15, desdeUtc = null, hastaUtc = null, desc = true } = {}
  ) {
    const params = { page, pageSize, desc };
    if (desdeUtc) params.desdeUtc = desdeUtc;
    if (hastaUtc) params.hastaUtc = hastaUtc;

    const { data } = await api.get(`/registros-sensores/sensor/${sensorId}`, { params });
    return data;
  },

  // 🔹 No-super: misma firma que usa MisEstadisticas (alias del endpoint por sensor)
  //    Recibe un objeto con sensorId y filtros; devuelve { items, total, ... } del backend.
  async buscar({
    sensorId,
    page = 1,
    pageSize = 15,
    desdeUtc = null,
    hastaUtc = null,
    desc = true,
  } = {}) {
    if (sensorId == null) throw new Error("buscar: sensorId es requerido");
    const params = { page, pageSize, desc };
    if (desdeUtc) params.desdeUtc = desdeUtc;
    if (hastaUtc) params.hastaUtc = hastaUtc;

    const { data } = await api.get(`/registros-sensores/sensor/${sensorId}`, { params });
    return data;
  },

  // 🔸 Solo superadmin:
  // GET /registros-sensores/buscar?usuarioId=&estanqueId=&sensorId=&q=&desdeUtc=&hastaUtc=&page=&pageSize=&desc=
  async buscarAdmin({
    usuarioId = null,
    estanqueId = null,
    sensorId = null,
    q = "",
    desdeUtc = null,
    hastaUtc = null,
    page = 1,
    pageSize = 15,
    desc = true,
  } = {}) {
    const params = { page, pageSize, desc };
    if (usuarioId) params.usuarioId = usuarioId;
    if (estanqueId) params.estanqueId = estanqueId;
    if (sensorId) params.sensorId = sensorId;
    if (q) params.q = q;
    if (desdeUtc) params.desdeUtc = desdeUtc;
    if (hastaUtc) params.hastaUtc = hastaUtc;

    const { data } = await api.get(`/registros-sensores/buscar`, { params });
    return data;
  },
};

export default registroSensoresService;
